import { composeThemeFromProps, Compose } from '@css-modules-theme/react';
import clsx from 'clsx';
import React, { useRef } from 'react';
import defaultStyles from './styles/Tabs.module.scss.js';
import { jsx } from 'react/jsx-runtime';
import { omit } from '../../utils/omit.js';

const TabPanelComponent = (props, ref) => {
  const {
    children,
    theme,
    title,
    lazyload,
    isActive,
    disabled,
    type,
    ...rest
  } = props;
  const styles = composeThemeFromProps(defaultStyles, {
    theme
  }, {
    compose: Compose.Merge
  });
  const shouldRender = useRef(false);
  shouldRender.current = lazyload ? shouldRender.current || isActive : true;
  return shouldRender.current && /*#__PURE__*/jsx("div", {
    ref: ref,
    ...omit(rest, ['title']),
    role: "tabpanel",
    tabIndex: disabled ? -1 : 0,
    "aria-labelledby": title.toString(),
    className: clsx(styles.panel, {
      [styles.panel_card]: type === 'card',
      [styles.panel_active]: isActive
    }),
    children: children
  });
};
const TabPanel = /*#__PURE__*/React.forwardRef(TabPanelComponent);
TabPanel.displayName = 'TabPanel';
TabPanel.isTabPanel = true;

export { TabPanel };
